import { render } from "./Sales.vue?vue&type=template&id=a39a7006&scoped=true&ts=true"
import script from "./Sales.vue?vue&type=script&lang=ts"
export * from "./Sales.vue?vue&type=script&lang=ts"

import "./Sales.vue?vue&type=style&index=0&id=a39a7006&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39a7006"]])

export default __exports__